import { icon, findIconDefinition } from '@fortawesome/fontawesome-svg-core';

/**
 * sets up fontawesome library and expose it as an angular service
 *
 * Documentation: https://fontawesome.com/how-to-use/font-awesome-api
 */
export const FontawesomeProvider = {
  provide: 'fontawesome',
  useValue: { icon, findIconDefinition },
};
